import Global from '../../js/constant.js'

const square = {
  state: {
    hashtagDivisionId : Global.hashtag_division_id.home, //ひろば ハッシュタグ区分 デフォルト：ホーム
    hashtagId: null,//ひろば ハッシュタグID
    hashtagIds: [], //ひろば 最近のハッシュタグ５件
  },
  getters: {
    hashtagDivisionId(state) { return state.hashtagDivisionId },
    hashtagId(state) { return state.hashtagId },
    hashtagIds(state) { return state.hashtagIds },
  },
  mutations: {
    setHashtagDivisionId (state, value) {
      state.hashtagId = null
      state.hashtagIds = []
      state.hashtagDivisionId = value
    },
    setHashtagId (state, value) {
      state.hashtagId = value
    },
    setHashtagIds (state, value) {
      state.hashtagIds = value
    },
  },
  actions: {},
  modules: {}
}
export default square